if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      setActiveMedia(mediaId, smooth = false) {
        // Find the slide with the matching media ID
        // The mediaId format is: "sectionId-mediaId" (e.g., "main-123456789")
        const mediaIdParts = mediaId.split('-');
        const actualMediaId = mediaIdParts.length > 1 ? mediaIdParts[mediaIdParts.length - 1] : mediaId;

        // Try to find by data-media-id attribute on li elements (for grid layout)
        let targetSlide = this.querySelector(`li[data-media-id="${actualMediaId}"]`);

        // If not found, try to find element with data-media-id attribute (could be in swiper slides)
        if (!targetSlide) {
          targetSlide = this.querySelector(`[data-media-id="${actualMediaId}"]`);
        }

        // If still not found, try to find by ID pattern (product-mediaId-index)
        if (!targetSlide) {
          const allSlides = this.querySelectorAll('[data-media-id], .swiper-slide, [id*="product-"]');
          for (const slide of allSlides) {
            const slideMediaId = slide.getAttribute('data-media-id');
            const slideId = slide.id || '';
            if (slideMediaId === actualMediaId || slideId.includes(actualMediaId) || slideId === mediaId) {
              targetSlide = slide;
              break;
            }
          }
        }

        if (!targetSlide) {
          console.warn(`Media gallery: Could not find slide with media ID: ${mediaId} (actual: ${actualMediaId})`);
          return;
        }

        // Check if this is a swiper slideshow
        const swiperComponent = this.querySelector('swiper-component');
        if (swiperComponent) {
          // Wait for swiper to be initialized if needed
          const findSwiperInstance = () => {
            // Check if swiper-component has swiper property
            if (swiperComponent.swiper) {
              return swiperComponent.swiper;
            }
            // Check if swiper-component has initSwiper property (from global.js)
            if (swiperComponent.initSwiper) {
              return swiperComponent.initSwiper;
            }
            // Try to find swiper instance in the swiper element
            const swiperEl = swiperComponent.querySelector('.swiper');
            if (swiperEl && swiperEl.swiper) {
              return swiperEl.swiper;
            }
            return null;
          };

          const swiperInstance = findSwiperInstance();

          if (swiperInstance) {
            // Find the slide index
            const slides = swiperInstance.slides || swiperInstance.el?.querySelectorAll('.swiper-slide') || [];
            let slideIndex = -1;

            // Try to find the slide that contains our target element
            for (let i = 0; i < slides.length; i++) {
              const slide = slides[i];
              if (slide.contains(targetSlide) || slide === targetSlide ||
                slide.querySelector(`[data-media-id="${actualMediaId}"]`)) {
                slideIndex = i;
                break;
              }
            }

            if (slideIndex !== -1) {
              swiperInstance.slideTo(slideIndex, smooth ? 600 : 0);
            } else {
              console.warn(`Media gallery: Could not find slide index for media ID: ${mediaId}`);
            }
          } else {
            // Swiper not initialized yet, try to scroll to element
            targetSlide.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'nearest' });
          }
        } else {
          // For non-swiper galleries (grid), calculate precise offset
          // to account for sticky header and avoid scrollIntoView silent failures
          const header = document.querySelector('sticky-header, .header-wrapper');
          const headerHeight = header ? header.clientHeight : 0;
          const targetTop = targetSlide.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: targetTop - headerHeight - 20, // 20px breathing room
            behavior: smooth ? 'smooth' : 'auto'
          });
        }
      }
    }
  );
}